import { render, staticRenderFns } from "./EmojiIcon.vue?vue&type=template&id=1a7c780e&scoped=true"
import script from "./EmojiIcon.vue?vue&type=script&lang=js"
export * from "./EmojiIcon.vue?vue&type=script&lang=js"
import style0 from "./EmojiIcon.vue?vue&type=style&index=0&id=1a7c780e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7c780e",
  null
  
)

export default component.exports